<template>
  <div class="pageBox" :lang="isArab?'ar' : 'en'" :dir="isArab?'rtl' : 'ltr'">
      <div class="newbox">
          <div class="titleArea">
              <div class="titleText">{{isArab ? "ما الجديد" : "What's New"}}</div>
          </div>
          <div class="quesUl">
              <div class="quesLi" v-for="(item, index1) in newQuesArr" v-bind:key="index1">
                  <div class="showArea" @click="showDetailDesc(index1)">
                      <div class="detailText">{{item.ques}}</div>
                      <div class="downIcon" >
                          <div  v-if="newQuesArrShowIndex == index1" class="upicon1"></div>
                          <div  v-if="!(newQuesArrShowIndex == index1)" class="downicon1"></div>
                      </div>
                  </div>
                  <div class="hideArea" v-if="newQuesArrShowIndex == index1">
                     <div class="quesDetailText">
                         <p v-if="!!item.answer">{{item.answer}}</p>
                         <br v-if="!!item.answer"/>
                         <p v-for="(itemli,index) in item.answerItem" v-bind:key="index">{{index+1}}. {{itemli.itemText}}</p>
                         <div class="toFeedBack" @click="toFeedBackPage(index1)">
                             <p>{{toFeed}}</p>
                         </div>
                     </div>
                  </div>
              </div>
          </div>
      </div>
      <div class="popularbox">
          <div class="titleArea">
              <div class="titleText">{{isArab ? "المواضيع الأكثر شعبية" : "Popular Topics"}}</div>
          </div>
          <div class="quesUl">
              <div class="quesLi" v-for="(item, index) in popularArr" v-bind:key="index">
                  <div class="showArea" @click="toDetailPage(index)">
                      <div class="detailText">
                          <p class="topicText1">{{item.title}}</p>
                          <p class="topicText2">{{item.desc}}</p>
                      </div>
                      <div class="downIcon" >
                          <div  v-if="!isArab"  class="todetailpageIcon1"></div>
                          <div  v-if="isArab"  class="todetailpageIcon2"></div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
      <transition name="slide-fade">
        <div v-if="showButton" :class="['help-button', {'arab-style': isArab}]" @click="go2Chat">
          <img src="../assets/Ic_live chat_Help@2x.png" alt="">
        </div>
      </transition>
  </div>
</template>

<script>
import {newQusArrData,popularQuesData} from './../json/data'
import {_di, iframeInsert } from './../common/js/di';
export default {
  name: 'HelpPage',
  data () {
    return {
      newQuesArr: [],
      popularArr: [],
      newQuesArrShowIndex: null,
      isArab: false,
      toFeed: "Still need help? Click here send feedback >",
      eventTrack:null,
      userId: '',
      token: '',
      showButton: false
    }
  },
  created(){
    document.title = "Help";
  },
  mounted(){
    var lang = this.getUrlParam("lang");
    this.userId = this.getUrlParam('userId') || 120058;
    this.token = this.getUrlParam("token")
    console.log(lang)
    this.isArab = lang == "ar"?true: false;
    // console.log(process.env);
    console.log(popularQuesData)
    this.toFeed = this.isArab ? "تحتاج للمزيد من المساعدة، اضغط هنا لإرسال إستفساراتك وإقتراحتك." : "Still need help? Click here send feedback >";
    this.newQuesArr = this.isArab ? newQusArrData["ar"] : newQusArrData["en"];
    this.popularArr = this.isArab ? popularQuesData["ar"] : popularQuesData["en"];
    //di打点相关
    this.eventTrack = {
        helppageenter: _di('settings.help',42614),
        topicclick: _di('help.topics',42615),
        answerclick: _di('help.answer',42616),
        helplinkclick: _di('help.contact',42617),
        zendeskClick: _di('zendesk.click', 14543)
    }
    //打点
    this.eventTrack.helppageenter({
        "user_id": this.userId,
    });

    this.chenVersion('4.5.0200819', (err,newVerison) =>{
        if(err){console.error(err)}
        if(newVerison){
            this.checkLevel(10, (err, gap) =>{
                if(err){console.error(err)}
                if(gap >= 0){
                    this.showButton = true
                }else{
                    this.showButton = false
                }
            })
        }
    })
  },
  methods: {
    checkLevel(mixLevel, callback){
        this.$axios({
            method: 'GET',
            url: '/api/profile/level',
            baseURL: location.origin,
            params: {
                token: this.token,
                uid: this.userId,
            }
        }).then(res => {
            const level = res.data.level 
            const gap = level - mixLevel
            callback(0, gap)
        }).catch(e =>{
            callback(e)
        })
    },
    chenVersion(lastVersion, callback){
        const userAgent = navigator.userAgent
        const versions = userAgent.match(/\bloops\/(\S*)/);

        if(versions){
            const version = versions[1]
            const newVersionNum = version.split('.')

            const oldVersionNum = lastVersion.split('.')

            if(!newVersionNum[0] || !newVersionNum[1] || !newVersionNum[2]){
                callback('Incorret version number')
            }
            if(!oldVersionNum[0] || !oldVersionNum[1] || !oldVersionNum[2]){
                callback('Agu Err: Incorret version number')
            }
            if(newVersionNum[0] > oldVersionNum[0]
            || (newVersionNum[0] === oldVersionNum[0] && newVersionNum[1] > oldVersionNum[1])
            || (newVersionNum[0] === oldVersionNum[0] && newVersionNum[1] === oldVersionNum[1] && newVersionNum[2] > oldVersionNum[2])
            ){
                // new version
                callback(0, true)
            }else{
                callback(0, false)
            }
        }else{
            callback('No match version')
        }
    },
    test(){
       console.log(88888);
    },
    showDetailDesc(index){
        // console.log(index,this.newQuesArrShowIndex)
       if(this.newQuesArrShowIndex == index){
           this.newQuesArrShowIndex = null;
       }else{
           this.newQuesArrShowIndex = index;
       }
       //打点
        this.eventTrack.answerclick({
            "user_id": this.userId,
            "question_id": index,
            "topic_id": null,
        });
    },
    toDetailPage(index){
        //打点
        this.eventTrack.topicclick({
            "user_id": this.userId,
            "topic_id": index,
        });
        this.$router.push({
            path: '/categorydetail',
            query: {
                indexNum: index,
                isArab: this.isArab
            },
        });
    },
    toFeedBackPage(index){
        //打点
        this.eventTrack.helplinkclick({
            "user_id": this.userId,
            "question_id": index,
            "topic_id": null,
        });
        var linkurl = "loopsmozat://general/feedback";
        window.location.href = linkurl;
    },
    getUrlParam(name) {
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
        var r = window.location.search.substr(1).match(reg);
        if (r != null) return unescape(r[2]); return null;
    },
    go2Chat(){
        this.eventTrack.zendeskClick({
            uid: this.userId,
            type: 4
        })
        iframeInsert('util/openAppPage?pageName=zendesk')
    }
  },
  
  
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .pagebox{
     width: 100%;
  }
  .todetailpageIcon1{
      width: 100%;
     background: url('./../assets/arrow_right_new.png');
     background-size:100%
  }
  .todetailpageIcon2{
      width: 100%;
     background: url('./../assets/arrow_left_new.png');
     background-size:100%
  }
  .titleArea{
    width: 100%;
    height: 0.64rem;
    background: rgb(250, 250, 250);
    display: flex;
    justify-content: center;
  }
  .titleText{
    width: 3.45rem;
    height: 0.44rem;
    line-height: 0.44rem;
    margin-top: 0.2rem;
    font-size: 0.2rem;
    color: rgb(38,39, 41);
    font-weight: bolder;
  }
  .quesUl{
     width: 100%;
     position: relative;
  }
  .quesUl:after {
    content: '';
    position: absolute;
    left: 0;
    bottom:0;
    background: rgb(232, 232, 232);
    width: 100%;
    height: 1px;
    -webkit-transform: scaleY(0.5);
    transform: scaleY(0.5);
    -webkit-transform-origin: 0 0;
    transform-origin: 0 0;
    z-index: -1;
}
  .quesLi{
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .quesLi:after {
    content: '';
    position: absolute;
    left: 0;
    bottom:0;
    background: rgb(232, 232, 232);
    width: 100%;
    height: 1px;
    -webkit-transform: scaleY(0.5);
    transform: scaleY(0.5);
    -webkit-transform-origin: 0 0;
    transform-origin: 0 0;
    z-index: -1;
}
  .showArea{
    width: 3.45rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .detailText{
     width: 3rem;
     line-height: 0.18rem;
     font-size: 0.14rem;
     color: rgb(38, 39, 41);
     margin: 0.22rem 0;
     font-weight: bolder;
  }
  .detailText2{
     width: 3rem;
     line-height: 0.18rem;
     font-size: 0.14rem;
     color: rgb(38, 39, 41);
     margin: 0.14rem 0;
     font-weight: bolder;
  }
  .topicText1{
     color: rgb(0, 0, 0);
     font-weight: bolder;
     font-size: 0.16rem;
     line-height: 0.2rem;
  }
  .topicText2{
     color: rgb(178,178,178);
     font-size: 0.14rem;
     line-height: 0.18rem;
     font-weight: normal;
  }
  .downIcon{
    width: 0.3rem;
    height: 0.4rem;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .downIcon img{
    width: 0.2rem;
  }
  .downIcon div{
      width: 0.2rem;
      height: 0.2rem;
  }
  .upicon1{
      /* background: red; */
      background: url("./../assets/arrow_up_new.png");
      background-size: 100%;
  }
  .downicon1{
      /* background: red; */
      background: url("./../assets/arrow_down_new.png");
      background-size: 100%;
  }
  .hideArea{
     width: 3.45rem;
  }
  .quesDetailText{
      width: 3rem;
      
  }
  .quesDetailText p{
      font-size: 0.14rem;
      color: rgb(0, 0, 0);
      line-height: 0.16rem;
  }
  .toFeedBack{
      width: 100%;
      height: 0.66rem;
      display: flex;
      align-items: center;
  }
  .toFeedBack p{
      line-height: 0.16rem;
      font-size: 0.14rem;
      color: #51d287;
      font-weight: bolder;
      text-decoration: underline;
  }

  .help-button{
      width: 60px;
      height: 60px;
      position: fixed;
      bottom: 20px;
      right: 20px;
  }

  .arab-style.help-button{
      left: 20px;
      right: initial;
  }
  
  .help-button img{
      width: 100%;
      height: 100%;
  }

  .slide-fade-enter-active {
    transition: all .3s ease;
  }
  .slide-fade-leave-active {
    transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }
  .slide-fade-enter, .slide-fade-leave-to{
    transform: translateY(20px);
    opacity: 0;
   }
</style>


// WEBPACK FOOTER //
// src/components/HelpPage.vue